const PlaylistDragPreview = (props) => {
  const item = props.monitorProps.item
  return (
    <div className="">
      <div className=""></div>
      <div className="">{item.text}</div>
    </div>
  )
}

export default PlaylistDragPreview
